"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderRadioInput = void 0;
const lit_1 = require("lit");
const if_defined_js_1 = require("lit/directives/if-defined.js");
/**
 * radio 계열(mm-radio, mm-radio-card)이 공유하는 네이티브 input·label·인디케이터 조립과 change 처리.
 * label 안에 무엇을 둘지는 각 컴포넌트가 정한다.
 */
function renderRadioInput(host, inputId, toggle, label) {
    const handleInputChange = (event) => {
        event.stopPropagation(); // 네이티브 이벤트 전파 차단
        const target = event.target;
        toggle.set(target.checked);
    };
    return (0, lit_1.html) `
    <input
      type="radio"
      id=${inputId}
      name=${(0, if_defined_js_1.ifDefined)(host.name || undefined)}
      .value=${host.value || ''}
      .checked=${host.checked}
      ?disabled=${host.disabled}
      @change=${handleInputChange}
    />
    <label for=${inputId}>
      <span class="indicator"></span>
      ${label}
    </label>
  `;
}
exports.renderRadioInput = renderRadioInput;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmFkaW8udXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJyYWRpby51dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw2QkFBMEI7QUFDMUIsZ0VBQXdEO0FBV3hEOzs7R0FHRztBQUNILFNBQWdCLGdCQUFnQixDQUM5QixJQUFvQixFQUNwQixPQUFlLEVBQ2YsTUFBbUMsRUFDbkMsS0FBYztJQUVkLE1BQU0saUJBQWlCLEdBQUcsQ0FBQyxLQUFZLEVBQUUsRUFBRTtRQUN6QyxLQUFLLENBQUMsZUFBZSxFQUFFLENBQUEsQ0FBQyxpQkFBaUI7UUFFekMsTUFBTSxNQUFNLEdBQUcsS0FBSyxDQUFDLE1BQTBCLENBQUE7UUFDL0MsTUFBTSxDQUFDLEdBQUcsQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFDLENBQUE7SUFDNUIsQ0FBQyxDQUFBO0lBRUQsT0FBTyxJQUFBLFVBQUksRUFBQTs7O1dBR0YsT0FBTzthQUNMLElBQUEseUJBQVMsRUFBQyxJQUFJLENBQUMsSUFBSSxJQUFJLFNBQVMsQ0FBQztlQUMvQixJQUFJLENBQUMsS0FBSyxJQUFJLEVBQUU7aUJBQ2QsSUFBSSxDQUFDLE9BQU87a0JBQ1gsSUFBSSxDQUFDLFFBQVE7Z0JBQ2YsaUJBQWlCOztpQkFFaEIsT0FBTzs7UUFFaEIsS0FBSzs7R0FFVixDQUFBO0FBQ0gsQ0FBQztBQTVCRCw0Q0E0QkMifQ==